import { useFormik } from "formik"
import { AyudantiaInvestigacion, AyudantiaInvestigacionData, CastSolicitudAyudantiaDTO, solicitudAprobacionDTO, VoidAyudantiaInvestigacion } from "../../interfaces/AYUDANTIAS/Ayudantia"
import AyudantiaService from "../../services/AyudantiaService"
import { useState } from "react"
import { voidSolicitudAyudanteInv } from "../../interfaces/AYUDANTIAS/SolicitudAyud"
import { VoidTblDetalleSolicitudAyud } from "../../interfaces/AYUDANTIAS/TblDetalleSolicitudAyud"
import { Alert, Button, Container, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material"
import { useAppSelector } from "../../redux/hooks"
import { AccionHorasValidate, AccionSolicitudAyudantiaValidate } from "../ValidationForm/validationForm"
import { MdSave } from "react-icons/md"
import AlertService from "../../services/AlertService"
import { EstudianteActivoT } from "../../interfaces/SAAC/EstudianteActivo"




interface Props{
    token: any,
    data: AyudantiaInvestigacionData,
    estudiante : EstudianteActivoT,
    onResponse?: (dataRespuesta: any) => void,
    onResponseRechazo?: (dataRespuesta: any) => void,
    onClose: () => void,
    tipobtn : string
    //onClean?: (dataRespuesta: any) => void 
}

const ayudantiaService = new AyudantiaService();
const alertaService = new AlertService();
export const AccionSolicitudAyudantia: React.FC<Props> = ({token, data, onClose, onResponse,onResponseRechazo, estudiante, tipobtn}) => {
    const { userData } = useAppSelector((state) => state.authReducer);
    const [mensajes, setMensajes] = useState<Array<string>>([]);
    const [tipoBtnPresionado, setTipoBtnPresionado] = useState("");

    const formik = useFormik({
        initialValues :{
            horas : data.horas > 0 ? data.horas.toString() : '',
            //horas: '5',
            comentario: ''
        },
        enableReinitialize: true,
        validationSchema : tipobtn =="A" ?  AccionHorasValidate : AccionSolicitudAyudantiaValidate,
        onSubmit: async (values) =>{
            onClose();
            alertaService.showLoading("procesando...");

            if(tipoBtnPresionado ==="A"){
                let obj = CastSolicitudAyudantiaDTO(values.horas,values.comentario,data.codestudiante,data.iddetallesolicitud);
                GuardarAprobacionSolicitudAyudInv(obj);
            }else{
                let obj = CastSolicitudAyudantiaDTO(values.horas,values.comentario,data.codestudiante,data.iddetallesolicitud);
                GuardarRechazoSolicitudAyudantia(obj);
            }
        }
    });

    const GuardarRechazoSolicitudAyudantia = async(solicitud: solicitudAprobacionDTO) => {
        try{
            let listaSolicitudesRechazo: solicitudAprobacionDTO[] = [solicitud];
            setMensajes([]);
            let tipoPersona = userData.rolesInvestigacion.find(x=>x.idrol == 151) ? 'S':'';
            await ayudantiaService.RechazarSolicitudMultiple(token,listaSolicitudesRechazo,userData.idpersona,tipoPersona)
            .then((response)=>{
                if(response.status.isSuccessfully){
                    if(onResponseRechazo){
                        onResponseRechazo(response);
                    }else{
                        console.error('La función onResponse no está definida.')
                    }
                }else{
                    setMensajes(response.status.messages);
                    alertaService.hideLoading();
                    alertaService.alertaAdvertenciaList('Alerta', response.status.messages[0].split('|').filter((msg: string) => msg.trim() !== ''));
                }
            }).catch((error) => {
                console.error(error)
            });

        }catch(error){
            console.error('Error:',error)
        }
    }

    const GuardarAprobacionSolicitudAyudInv = async( solicitud: solicitudAprobacionDTO) => {
        try{
            let listaSolicitudes: solicitudAprobacionDTO[] = [solicitud];
            setMensajes([]);
            let tipoPersona = userData.rolesInvestigacion.find(x=>x.idrol == 151) ? 'S':'';
            await ayudantiaService.AprobarSolicitudMultiple(token,listaSolicitudes,userData.idpersona,tipoPersona)
                .then((response)=>{
                    if(response.status.isSuccessfully){
                        if(onResponse){
                            onResponse(response);
                        }else{
                            console.error('La función onResponse no está definida.')
                        }
                    }else{
                        setMensajes(response.status.messages);
                        //alertaService.hideLoading();
                        alertaService.alertaAdvertenciaList('Alerta', response.status.messages[0].split('|').filter((msg: string) => msg.trim() !== ''));
                    }
                })
                .catch((error) => {
                    console.error(error)
                });
        }catch(error){
            console.error('Error:',error)
        }
    }


    return(

        <Container maxWidth="sm" style={{ borderRadius: '5px', padding: '20px', textAlign: 'center' }}>
            {
                estudiante.estudianteValido.length>0 ? 
                <>
                    <Typography variant="body1"><strong>Impedimento:</strong></Typography>
                    <ul>
                        {estudiante.estudianteValido.map((est, index) => (
                        <li key={`impedimento-${index}`}>{est.mensaje}</li>
                        ))}
                    </ul>
                </>
                :
                <></>
            }


            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormControl sx={{m:1}} fullWidth error={Boolean(formik.errors.horas && formik.touched.horas)} >
                            <InputLabel htmlFor="select-horas">Horas</InputLabel>
                            {
                                data.horas > 5 ? 
                                <Select
                                    labelId="select-horas"
                                    name="horas"
                                    label='Horas'
                                    variant="outlined"
                                    value={formik.values.horas}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    sx={{ marginBottom: '20px', width: '100%' }}

                                    
                                    style={ tipobtn ==='R'? { pointerEvents: 'none', backgroundColor: '#f0f0f0' } : {}}
                                >
                                    <MenuItem value={'5'}>5</MenuItem>
                                    <MenuItem value={'10'}>10</MenuItem>
                                </Select>
                                :
                                <Select
                                    labelId="select-horas"
                                    name="horas"
                                    label='Horas'
                                    variant="outlined"
                                    value={formik.values.horas}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    sx={{ marginBottom: '20px', width: '100%' }}
                                    style={ tipobtn ==='R'? { pointerEvents: 'none', backgroundColor: '#f0f0f0' } : {}}
                                >
                                    <MenuItem value={'5'}>5</MenuItem>
                                </Select>

                            }
                            
                            {formik.touched.horas && formik.errors.horas && (
                                <Alert severity="error">{formik.errors.horas}</Alert>
                            )} 
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl sx={{m:1}} fullWidth error={Boolean(formik.errors.comentario && formik.touched.comentario)}>
                            <TextField
                                fullWidth
                                id="comentario"
                                name="comentario"
                                label="Comentario"
                                value={formik.values.comentario}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error ={formik.touched.comentario && Boolean(formik.errors.comentario)}
                            />
                            {formik.touched.comentario && formik.errors.comentario && (
                                <Alert severity="error">{formik.errors.comentario}</Alert>
                            )}
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        {/* {
                            estudiante.estudianteValido.length > 0 ?
                            <Button
                                sx={{
                                    marginRight: 1, backgroundColor: "#243165",
                                    color: "#FFFFFF !important",
                                    "&:hover": { backgroundColor: "#1e284c" },
                                    boxShadow: 3,
                                }}
                                type ='submit'
                                variant='contained'
                                endIcon = {<MdSave />}
                            >
                                Aceptar
                            </Button>
                        } */}

                        {
                            tipobtn==="A" ?
                            <Button
                                sx={{
                                    marginRight: 1, backgroundColor: "#243165",
                                    color: "#FFFFFF !important",
                                    "&:hover": { backgroundColor: "#1e284c" },
                                    boxShadow: 3,
                                }}
                                type ='submit'
                                variant='contained'
                                endIcon = {<MdSave />}
                                onClick={() => setTipoBtnPresionado("A")}
                            >
                                Aceptar
                            </Button>
                            :
                            <Button
                                sx={{
                                    marginRight: 1, backgroundColor: "#243165",
                                    color: "#FFFFFF !important",
                                    "&:hover": { backgroundColor: "#1e284c" },
                                    boxShadow: 3,
                                }}
                                type ='submit'
                                variant='contained'
                                endIcon = {<MdSave />}
                                onClick={() => setTipoBtnPresionado("R")}
                            >
                                Rechazar
                            </Button>

                        }
                    </Grid>

                </Grid>

            </form>
        </Container>
        
       
    );
}